var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStaciaMonogram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 33,
    viewBox: "0 0 49 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2763 12.5391C37.5366 12.5391 36.8852 13.0392 36.6847 13.7652L33.8572 23.9582C33.6568 24.6769 33.0148 25.1771 32.2799 25.1844L7.97214 25.4126C4.26406 25.4782 1.14536 29.3218 0 32.2938H39.5004C40.2592 32.2938 40.9202 31.7693 41.1063 31.019L42.5094 25.3203H42.5667L43.9243 20.4278C45.0196 16.4822 42.1968 12.5391 38.2763 12.5391Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0091 0H8.51346C7.75466 0 7.09369 0.524462 6.90758 1.27473L5.50452 6.97341H5.44725L4.08953 11.866C2.99428 15.8116 5.81711 19.7547 9.73756 19.7547C10.4773 19.7547 11.1287 19.2546 11.3291 18.5285L14.1568 8.33555C14.3572 7.61685 14.999 7.11666 15.734 7.10938L40.0417 6.88114C43.7499 6.81558 46.8804 2.97195 48.0258 0H48.0068H48.0091Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3075 14.1329C29.3611 14.1212 30.3057 13.131 30.6324 12.6094H19.9237C19.2678 12.6094 18.7067 13.0661 18.5837 13.6945L18.5553 13.836H18.5387L17.4424 19.438L17.3904 19.8137C17.3904 19.8137 17.3246 20.2936 17.6082 20.2936V20.2982H29.4462C29.1195 19.7743 28.059 18.8978 27.0053 18.8862H20.8542C19.9634 18.8862 20.0209 18.4225 20.0209 18.4225L20.8542 14.8724C21.0033 14.2788 21.0531 14.1352 21.6782 14.1329H28.3075Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaciaMonogram);
export default __webpack_public_path__ + "static/media/Stacia Monogram.83d6f5fdc0abce29456b2996c1091ba6.svg";
export { ForwardRef as ReactComponent };